import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeAuthCode, useBootstrapAuth } from "@/lib/auth";

export function OAuthCallbackPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const bootstrap = useBootstrapAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    (async () => {
      const result = await exchangeAuthCode(params);
      if (!result.ok) {
        setError(result.error ?? "unknown error");
        return;
      }
      // Hydrate the user state from the Hub's /v1/me.
      await bootstrap();
      navigate(result.returnTo, { replace: true });
    })();
  }, [location.search, navigate, bootstrap]);

  return (
    <div className="mx-auto mt-32 max-w-md px-4 text-center">
      {error ? (
        <div>
          <h1 className="text-xl font-semibold text-red-500">Login failed</h1>
          <p className="mt-2 text-sm text-neutral-500">{error}</p>
          <button
            onClick={() => navigate("/login")}
            className="mt-6 rounded-md bg-neutral-900 px-4 py-2 text-sm text-white hover:bg-neutral-700"
          >
            Try again
          </button>
        </div>
      ) : (
        <>
          <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-neutral-300 border-t-neutral-900" />
          <p className="mt-4 text-sm text-neutral-500">Finishing sign-in…</p>
        </>
      )}
    </div>
  );
}
